var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _vm.price
        ? [
            _c("strong", [
              _vm._v(
                _vm._s(_setup.formatPrice(_vm.price.v[0])) + " \n            "
              ),
              _c("span", { attrs: { title: _setup.title() } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_setup.symb(_vm.price.v[1])) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            !_setup.props.sum ? [_vm._v(" / чел.")] : _vm._e(),
          ]
        : [_c("strong", [_vm._v("-- ---  ")])],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }